import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { B2bProgramType } from '../../../../shared/models/b2b-program-type';
import { TranslatePipe } from '@ngx-translate/core';


export enum UploadRidersFileType {
    Add = 'Add',
    Remove = 'Remove',
}

/**
 * Load file for b2b program form
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'b2b-program-file-upload',
    templateUrl: './b2b-program-file-upload.component.html',
    styleUrls: ['./b2b-program-file-upload.component.scss'],
    imports: [
        TranslatePipe,
    ],
})
export class B2bProgramFileUploadComponent {
    /**
     * Loading flag
     */
    @Input() public loadingFile: boolean;
    /**
     * B2b program type
     */
    @Input() public b2bPrgType: B2bProgramType;
    /**
     * Load file event
     *
     * @returns Form data
     */
    @Output() public uploadFile: EventEmitter<{ body: { file: Blob; type: UploadRidersFileType } }> = new EventEmitter<{
        body: { file: Blob; type: UploadRidersFileType };
    }>();

    @ViewChild('fileInput') public fileInput: ElementRef;

    public readonly b2bProgramTypeEnum: typeof B2bProgramType = B2bProgramType;
    public readonly uploadRidersFileType: typeof UploadRidersFileType = UploadRidersFileType;
    /**
     * Action type
     */
    public type: UploadRidersFileType;

    public fileChange(event: Event): void {
        const fileArray: FileList | null = (event.target as HTMLInputElement).files;
        // eslint-disable-next-line unicorn/prefer-spread
        const files: File[] = Array.from(fileArray);

        if (files?.length > 0) {
            this.uploadFile.emit({
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                file: files[0] as Blob,
                type: this.type,
            });

            this.fileInput.nativeElement.value = null;
        }
    }

    public openFileDialog(type: UploadRidersFileType): void {
        this.fileInput.nativeElement.click();
        this.type = type;
    }
}
